import { pct } from '../../lib/chartGeometry'

export interface StackedPart {
  label: string
  value: number
  tone: 'amber' | 'cyan' | 'faint' | 'green' | 'violet'
}

const FILL = { amber: '#ffb648', cyan: '#5eeaff', faint: '#837e73', green: '#7fe08a', violet: '#b69cff' } as const

export function StackedBar({ parts, ariaLabel }: { parts: StackedPart[]; ariaLabel: string }) {
  const total = parts.reduce((a, p) => a + p.value, 0)
  return (
    <div role="img" aria-label={ariaLabel}>
      <div className="flex w-full overflow-hidden bg-ink-600" style={{ height: 12 }}>
        {parts.map((p) => (
          <div key={p.label} style={{ width: `${pct(p.value, total)}%`, background: FILL[p.tone] }} title={`${p.label}: ${p.value}`} />
        ))}
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 font-mono text-[12px] text-paper-dim">
        {parts.map((p) => (
          <span key={p.label}>
            <span style={{ color: FILL[p.tone] }} aria-hidden="true">■</span> {p.label} {pct(p.value, total)}%
          </span>
        ))}
      </div>
    </div>
  )
}
